import { useState } from 'react';

const testimonials = [
  {
    name: 'Marco Bianchi',
    role: 'Direttore Tecnico',
    company: 'Edil Costruzioni SpA',
    image: 'https://public.readdy.ai/ai/img_res/150336db8de5df6673a06e3b95740f78.jpg',
    text: 'Collaboriamo con LA.RA. SERVICE da oltre tre anni e la loro affidabilità è impeccabile. Consegne sempre puntuali e materiali di altissima qualità. Un partner strategico per la nostra azienda.',
    rating: 5
  },
  {
    name: 'Giulia Rossi',
    role: 'Responsabile Acquisti',
    company: 'Meccanica Industriale Srl',
    image: 'https://readdy.ai/api/search-image?query=professional%20italian%20businesswoman%20portrait%20in%20elegant%20attire%20with%20friendly%20smile%20in%20corporate%20office%20environment&width=400&height=400&seq=test2&orientation=squarish',
    text: 'Le lavorazioni meccaniche di precisione sono eseguite con una cura maniacale dei dettagli. Il supporto tecnico è sempre disponibile e competente. Consigliatissimi!',
    rating: 5
  },
  {
    name: 'Alessandro Ferretti',
    role: 'Ingegnere Strutturista',
    company: 'Studio Tecnico Ferretti',
    image: 'https://readdy.ai/api/search-image?query=professional%20italian%20engineer%20portrait%20in%20business%20casual%20attire%20with%20confident%20look%20in%20modern%20technical%20office&width=400&height=400&seq=test3&orientation=squarish',
    text: 'La qualità delle strutture metalliche realizzate supera sempre le nostre aspettative. Professionalità e competenza tecnica ai massimi livelli. Un\'eccellenza italiana.',
    rating: 5
  }
];

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            Cosa Dicono i Nostri Clienti
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            La soddisfazione dei nostri clienti è la nostra migliore referenza
          </p>
        </div>

        <div className="relative">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className={`bg-slate-50 rounded-2xl p-8 transition-all duration-300 ${
                  index === activeIndex ? 'ring-2 ring-slate-700 shadow-2xl' : 'hover:shadow-lg'
                }`}
                onMouseEnter={() => setActiveIndex(index)}
              >
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 rounded-full overflow-hidden mr-4">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-slate-900">{testimonial.name}</h4>
                    <p className="text-sm text-slate-600">{testimonial.role}</p>
                    <p className="text-sm text-slate-500">{testimonial.company}</p>
                  </div>
                </div>

                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-500 text-lg"></i>
                  ))}
                </div>

                <p className="text-slate-700 leading-relaxed italic">
                  "{testimonial.text}"
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}